import jqRequest from '../jqRequest'
import voteUrls from '../urls/vote'

export default {
  // 获取投票详细
  ballotDetailed(data) {
    return jqRequest.requestWithToken(voteUrls.ballotDetailed, data);
  },
  // 提交投票
  addBallotData(data){
    return jqRequest.requestWithToken(voteUrls.addBallotData, data);
  }
}